export class MetaproductSelectorBase {
  productSelector(product) {
    const defaultChild = this.defaultSelector(product);
    if (defaultChild) {
      return defaultChild;
    }
    return this.productSpecificSelector(product);
  }
  isValidProduct(childOptions, product) {
    const isValidState = childOptions.state.toLowerCase() == 'validated' || product.state.toLowerCase() == 'invisible' && childOptions.state.toLowerCase() == 'invisible';
    const isValidStockAndOutOfStockPolicy = childOptions.has_stock || !childOptions.has_stock && ['1', '2', '3'].includes(childOptions.stock_policy);
    return isValidState && isValidStockAndOutOfStockPolicy;
  }
  getChildMetaProduct(product) {
    const options = product?.specificV4.options;
    const childrens = product?.specificV4?.options?.EN.options;
    if (!options || childrens.length === 0) {
      throw new Error(`Impossible to navigate to the meta chidren: children within the meta-product(${product.id}) not found`);
    }
    const hasTwoMetaLevels = childrens.filter(child => child.options).length !== 0;
    let allChildrens = [];
    if (hasTwoMetaLevels) {
      allChildrens = childrens.flatMap(option => option.options ?? []);
    } else {
      allChildrens = childrens;
    }
    return allChildrens;
  }
  /**
   * Get productID by default that is setted in the custom field CF_KW_CHILD_PRESELECTED of the metaparent.
   * @param product
   * @returns productID by default or undefined if custom fields is not present or product is not valid
   */
  defaultSelector(product) {
    // Check if exists custom field
    const customField = product.custom_fields?.find(cf => cf.type === 'CF_CHILD_PRESELECTED');
    if (!customField) {
      return null;
    }
    // Check if productID is valid and children is valid
    const childID = customField.value;
    const allChildrens = this.getChildMetaProduct(product);
    const children = allChildrens.find(c => c.productID == childID);
    if (!children || !this.isValidProduct(children, product)) {
      return null;
    }
    return childID;
  }
}
